import React from 'react';
import RadioButton from './RadioButton'; // Импортируем компонент RadioButton

function RadioButtonsGroup({ options, name, selectedValue, onChange, title }) {
  return (
    <div>
      {/* Используем переданный проп `title` */}
      <label className="form-label fs-4">{title}</label>
      {options.map((option, index) => (
        <RadioButton
          key={index}
          id={`radio${index + 1}`}
          name={name}
          value={option.value}
          label={option.label}
          onChange={onChange}
          checked={selectedValue === option.value} // Устанавливаем выбранное значение
        />
      ))}
    </div>
  );
}

export default RadioButtonsGroup;
